/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ImportInputs */

const en_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription Import...`)
};

const fr_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de transcription...`)
};

const de_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkriptimport...`)
};

const it_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione della trascrizione...`)
};

const ru_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт транскрипции...`)
};

const es_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de transcripción...`)
};

const zh_cn2_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录导入...`)
};

const ja_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写インポート...`)
};

const hi_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन आयात...`)
};

const pt_pt2_transcription_import = /** @type {(inputs: Transcription_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de transcrição...`)
};

/**
* | output |
* | --- |
* | "Transcription Import..." |
*
* @param {Transcription_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_import = /** @type {((inputs?: Transcription_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_import(inputs)
	if (locale === "de") return de_transcription_import(inputs)
	if (locale === "it") return it_transcription_import(inputs)
	if (locale === "ru") return ru_transcription_import(inputs)
	if (locale === "es") return es_transcription_import(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_import(inputs)
	if (locale === "ja") return ja_transcription_import(inputs)
	if (locale === "hi") return hi_transcription_import(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_import(inputs)
	return en_transcription_import(inputs)
});